/**
 * Flushes pending autosaves when the tab is hidden, navigated away, or closed.
 *
 * The PRIMARY safety net is the hide-flush (visibilitychange → hidden, plus
 * pagehide for bfcache navigations): by the time unload fires there is usually
 * nothing left to save. beforeunload is only a BACKUP net — IndexedDB writes
 * started during beforeunload are not guaranteed to complete — so it kicks off
 * a best-effort flush and shows the native leave-warning while dirty.
 */

export function initUnloadGuard(store, { doc = document, win = window } = {}) {
  const flush = () => {
    if (!store.isDirty()) return;
    store.flushAutoSave().catch((err) => {
      console.warn('[UnloadGuard] Flush failed:', err);
    });
  };

  const onVisibilityChange = () => {
    if (doc.visibilityState === 'hidden') flush();
  };

  const onPageHide = () => {
    flush();
  };

  const onBeforeUnload = (e) => {
    if (!store.isDirty()) return;
    flush();
    e.preventDefault();
    e.returnValue = '';
  };

  doc.addEventListener('visibilitychange', onVisibilityChange);
  win.addEventListener('pagehide', onPageHide);
  win.addEventListener('beforeunload', onBeforeUnload);

  return {
    onVisibilityChange,
    onPageHide,
    onBeforeUnload,
    dispose() {
      doc.removeEventListener('visibilitychange', onVisibilityChange);
      win.removeEventListener('pagehide', onPageHide);
      win.removeEventListener('beforeunload', onBeforeUnload);
    }
  };
}
